import React from "react";
import { ResourceDescriptor } from "./common";
import { Link } from "react-router-dom";
import { defineMessages, FormattedMessage } from "react-intl";

const changesTranslations = defineMessages({
    role_added: { id: "audit.changes.role_added", defaultMessage: "Role added" },
    sessions_deleted: { id: "audit.changes.sessions_deleted", defaultMessage: "Sessions deleted" },
    totp_enabled: { id: "audit.changes.totp_enabled", defaultMessage: "Two-factor authentication enabled" },
    totp_disabled: { id: "audit.changes.totp_disabled", defaultMessage: "Two-factor authentication disabled" },
    mass_user_context_replace: { id: "audit.changes.mass_user_context_replace", defaultMessage: "Mass user context replace" },
    mass_alias_replace: { id: "audit.changes.mass_alias_replace", defaultMessage: "Mass alias replace" },
    mass_alias_delete: { id: "audit.changes.mass_alias_delete", defaultMessage: "Mass alias delete" },
    batch_alias_delete: { id: "audit.changes.batch_alias_delete", defaultMessage: "Batch alias delete" },
    aliases_removed: { id: "audit.changes.aliases_removed", defaultMessage: "Aliases removed" },
    email_verified: { id: "audit.changes.email_verified", defaultMessage: "Email verified" },
    email_invitation_resend: { id: "audit.changes.email_invitation_resend", defaultMessage: "Email invitation resent" },
    user_invited: { id: "audit.changes.user_invited", defaultMessage: "User invited" },
    email_verification_resent: { id: "audit.changes.email_verification_resent", defaultMessage: "Email verification resent" },
    role_revoked: { id: "audit.changes.role_revoked", defaultMessage: "Role revoked" },
    roles_revoked_by_context: { id: "audit.changes.roles_revoked_by_context", defaultMessage: "Roles revoked by context" },
    simplified_user_created: { id: "audit.changes.simplified_user_created", defaultMessage: "User created" },
    simplified_user_updated: { id: "audit.changes.simplified_user_updated", defaultMessage: "User updated" },
    simplified_user_deleted: { id: "audit.changes.simplified_user_deleted", defaultMessage: "User deleted" },
    user_created: { id: "audit.changes.user_created", defaultMessage: "User created" },
    user_updated: { id: "audit.changes.user_updated", defaultMessage: "User updated" },
    user_deleted: { id: "audit.changes.user_deleted", defaultMessage: "User deleted" },
    user_grant_created: { id: "audit.changes.user_grant_created", defaultMessage: "User grant created" },
    user_grant_updated: { id: "audit.changes.user_grant_updated", defaultMessage: "User grant updated" },
    user_grant_deleted: { id: "audit.changes.user_grant_deleted", defaultMessage: "User grant deleted" },
    user_context_created: { id: "audit.changes.user_context_created", defaultMessage: "User context created" },
    user_context_updated: { id: "audit.changes.user_context_updated", defaultMessage: "User context updated" },
    user_context_deleted: { id: "audit.changes.user_context_deleted", defaultMessage: "User context deleted" },
    managed_user_created: { id: "audit.changes.managed_user_created", defaultMessage: "Managed user created" },
    managed_user_updated: { id: "audit.changes.managed_user_updated", defaultMessage: "Managed user updated" },
    managed_user_deleted: { id: "audit.changes.managed_user_deleted", defaultMessage: "Managed user deleted" },
    client_role_mapping_rule_created: { id: "audit.changes.client_role_mapping_rule_created", defaultMessage: "Client role mapping rule created" },
    client_role_mapping_rule_updated: { id: "audit.changes.client_role_mapping_rule_updated", defaultMessage: "Client role mapping rule updated" },
    client_role_mapping_rule_deleted: { id: "audit.changes.client_role_mapping_rule_deleted", defaultMessage: "Client role mapping rule deleted" },
    client_role_mapping_context_substitution_created: { id: "audit.changes.client_role_mapping_context_substitution_created", defaultMessage: "Client role mapping context substitution created" },
    client_role_mapping_context_substitution_updated: { id: "audit.changes.client_role_mapping_context_substitution_updated", defaultMessage: "Client role mapping context substitution updated" },
    client_role_mapping_context_substitution_deleted: { id: "audit.changes.client_role_mapping_context_substitution_deleted", defaultMessage: "Client role mapping context substitution deleted" },
    ldap_auth_created: { id: "audit.changes.ldap_auth_created", defaultMessage: "LDAP auth created" },
    ldap_auth_updated: { id: "audit.changes.ldap_auth_updated", defaultMessage: "LDAP auth updated" },
    ldap_auth_deleted: { id: "audit.changes.ldap_auth_deleted", defaultMessage: "LDAP auth deleted" },
    client_created: { id: "audit.changes.client_created", defaultMessage: "Client created" },
    client_updated: { id: "audit.changes.client_updated", defaultMessage: "Client updated" },
    client_deleted: { id: "audit.changes.client_deleted", defaultMessage: "Client deleted" },
    permission_created: { id: "audit.changes.permission_created", defaultMessage: "Permission created" },
    permission_updated: { id: "audit.changes.permission_updated", defaultMessage: "Permission updated" },
    permission_deleted: { id: "audit.changes.permission_deleted", defaultMessage: "Permission deleted" },
    role_created: { id: "audit.changes.role_created", defaultMessage: "Role created" },
    role_updated: { id: "audit.changes.role_updated", defaultMessage: "Role updated" },
    role_deleted: { id: "audit.changes.role_deleted", defaultMessage: "Role deleted" },
    context_created: { id: "audit.changes.context_created", defaultMessage: "Context created" },
    context_updated: { id: "audit.changes.context_updated", defaultMessage: "Context updated" },
    context_deleted: { id: "audit.changes.context_deleted", defaultMessage: "Context deleted" },
    role_permission_created: { id: "audit.changes.role_permission_created", defaultMessage: "Role permission created" },
    role_permission_updated: { id: "audit.changes.role_permission_updated", defaultMessage: "Role permission updated" },
    role_permission_deleted: { id: "audit.changes.role_permission_deleted", defaultMessage: "Role permission deleted" },
    user_sub_created: { id: "audit.changes.user_sub_created", defaultMessage: "User sub created" },
    user_sub_updated: { id: "audit.changes.user_sub_updated", defaultMessage: "User sub updated" },
    user_sub_deleted: { id: "audit.changes.user_sub_deleted", defaultMessage: "User sub deleted" },
    user_info_created: { id: "audit.changes.user_info_created", defaultMessage: "User info created" },
    user_info_updated: { id: "audit.changes.user_info_updated", defaultMessage: "User info updated" },
    user_info_deleted: { id: "audit.changes.user_info_deleted", defaultMessage: "User info deleted" },
    user_address_created: { id: "audit.changes.user_address_created", defaultMessage: "User address created" },
    user_address_updated: { id: "audit.changes.user_address_updated", defaultMessage: "User address updated" },
    user_address_deleted: { id: "audit.changes.user_address_deleted", defaultMessage: "User address deleted" },
    change_password_updated: { id: "audit.changes.change_password_updated", defaultMessage: "Password changed" },
    change_password_created: { id: "audit.changes.change_password_created", defaultMessage: "Password changed" },
    language_created: { id: "audit.changes.language_created", defaultMessage: "Language created" },
    language_updated: { id: "audit.changes.language_updated", defaultMessage: "Language updated" },
    language_deleted: { id: "audit.changes.language_deleted", defaultMessage: "Language deleted" },
    user_email_created: { id: "audit.changes.user_email_created", defaultMessage: "User email created" },
    user_email_updated: { id: "audit.changes.user_email_updated", defaultMessage: "User email updated" },
    user_email_deleted: { id: "audit.changes.user_email_deleted", defaultMessage: "User email deleted" },
    user_alias_created: { id: "audit.changes.user_alias_created", defaultMessage: "User alias created" },
    user_alias_updated: { id: "audit.changes.user_alias_updated", defaultMessage: "User alias updated" },
    user_alias_deleted: { id: "audit.changes.user_alias_deleted", defaultMessage: "User alias deleted" },
    reset_password_updated: { id: "audit.changes.reset_password_updated", defaultMessage: "Password resetted" },
    token_created: { id: "audit.changes.token_created", defaultMessage: "Token created" },
    token_updated: { id: "audit.changes.token_updated", defaultMessage: "Token updated" },
    token_deleted: { id: "audit.changes.token_deleted", defaultMessage: "Token deleted" },
    user_logged_in: { id: "audit.changes.user_logged_in", defaultMessage: "User logged in" },
    user_logged_out: { id: "audit.changes.user_logged_out", defaultMessage: "User logged out" },
});

const getDisplayNameFromUserSub = (user_sub: any, defaultValue: string) => {
    return (
        user_sub?.user?.aliases[0]?.name ||
        user_sub?.user?.emails[0]?.address ||
        defaultValue
    );
}

const audit: ResourceDescriptor = {
    url: "audit",
    orders: {
        list: ["timestamp", "actor", "change", "client_id", "affected_user"],
    },
    crudActions: ["list"],
    listDefaults: {
        sort: {
            name: "timestamp",
            direction: "desc",
        },
        limit: 20,
        offset: 0,
    },
    renderers: {
        list: {
            timestamp: (val, _) => {
                return <span>{new Date(val).toLocaleString()}</span>;
            },
            actor: (_, row) => {
                const name = getDisplayNameFromUserSub(row.user_sub, row.actor);
                const user_id = row.user_sub?.user?.id;

                if (user_id) return <Link to={`/users/read/${user_id}`}>{name}</Link>;
                return name;
            },
            change: (val, _) => {
                return <FormattedMessage {...changesTranslations[val]} />;
            },
            client_id: (_, row) => {
                if (row.client_id) {
                    return <Link to={`/clients/read/${row.client_id}`}>{row.client.display_name}</Link>;
                }

                return "Heimdall";
            },
            affected_user: (_, row) => {
                const name = getDisplayNameFromUserSub(row.affected_user_sub, row.affected_user);
                const user_id = row.affected_user_sub?.user?.id;

                if (user_id) return <Link to={`/users/read/${user_id}`}>{name}</Link>;
                return name;
            }
        },
    },
    expand: {
        list: ["client", "user_sub", "user_sub.user", "user_sub.user.aliases", "user_sub.user.emails", "affected_user_sub", "affected_user_sub.user", "affected_user_sub.user.aliases", "affected_user_sub.user.emails"],
    },
};

export default audit;
